import React from 'react'
import { TutorNotificationPreferences } from '../../../../components/common/notifications/TutorNotificationPreferences'

export const TutorPreferences = () => {
  return (
     <TutorNotificationPreferences />
  )
}
